import { render, staticRenderFns } from "./AnnexInfo.view.vue?vue&type=template&id=cbababfe&"
import script from "./AnnexInfo.view.vue?vue&type=script&lang=js&"
export * from "./AnnexInfo.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbababfe')) {
      api.createRecord('cbababfe', component.options)
    } else {
      api.reload('cbababfe', component.options)
    }
    module.hot.accept("./AnnexInfo.view.vue?vue&type=template&id=cbababfe&", function () {
      api.rerender('cbababfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/purchases/contract/annex/sign/AnnexInfo.view.vue"
export default component.exports